import { useEffect, useState } from 'react';

/**
 * Delays turning a boolean flag ON by `delay` ms; turns OFF immediately.
 * Useful to avoid skeleton flicker when data arrives faster than the delay.
 */
export function useDelayedFlag(flag: boolean, delay = 180): boolean {
  const [delayed, setDelayed] = useState(false);
  useEffect(() => {
    if (!flag) {
      setDelayed(false);
      return;
    }
    const id = window.setTimeout(() => setDelayed(true), delay);
    return () => window.clearTimeout(id);
  }, [flag, delay]);
  return delayed;
}
